import { render, staticRenderFns } from "./BackofficeReservaHemocomponentes.vue?vue&type=template&id=2f4931f5&scoped=true"
import script from "./BackofficeReservaHemocomponentes.vue?vue&type=script&lang=ts"
export * from "./BackofficeReservaHemocomponentes.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeReservaHemocomponentes.vue?vue&type=style&index=0&id=2f4931f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4931f5",
  null
  
)

export default component.exports